module.exports = __webpack_public_path__ + "static/img/2.1.8ec1e67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/eng/2.1.png
// module id = o9d+
// module chunks = 0